export default {
  tabbar1: "หน้าแรก",
  tabbar2: "ชุมชน",
  tabbar3: "เลือกหญิง",
  tabbar4: "โรงแรม",
  tabbar5: "ของฉัน",
  login: "เข้าสู่ระบบ",
  userNamePlaceholder: "กรุณากรอกหมายเลขโทรศัพท์",
  passwordPlaceholder: "กรุณากรอกรหัสผ่าน",
  forgotPassword: "ลืมรหัสผ่าน?",
  noAccount: "ยังไม่มีบัญชี?",
  registerNow: "สมัครตอนนี้",
  register: "สมัครสมาชิก",
  inviteCodeePlaceholder: "กรุณากรอกรหัสเชิญ",
  consentAgreement: "ฉันได้อ่านและยอมรับข้อตกลงบัญชีและเงื่อนไขการทำธุรกรรม",
  highEndZone: "โซนพรีเมียม",
  EnjoyTheUltimateLuxuryExperience: "เพลิดเพลินกับประสบการณ์หรูหราสุดพิเศษ",
  airborne: "ไปส่ง",
  viewMoreData: "ดูเพิ่มเติม",
  aboutCannonRecommend: "ลิงก์แนะนำ",
  current: "ปัจจุบัน",
  peopleNowMatch: "คนกำลังจับคู่แบบออนไลน์",
  accountMembership: "บัตรนัดเดทถูกเปิดใช้งาน",
  highEnd: "หรู",
  authentication: "ยืนยัน",
  videoAuthentication: "ยืนยันวิดีโอ",
  tollRange: "ช่วงค่าบริการ",
  personHeight: "ส่วนสูง",
  bust: "รอบอก",
  serviceCity: "เมืองที่ให้บริการ",
  nationalAirborne: "ขนส่งทางอากาศทั่วประเทศ",
  askHerOut: "ชวนนัดเดท",
  uptodate: "ล่าสุด",
  play: "เล่น",
  reservation: "จอง",
  beautifulGirl: "สาวสวย",
  people: "คน",
  requiredPromotion: "ต้องการเลื่อนระดับ",
  integral: "แต้ม",
  rechargePoints: "เติมแต้ม",
  redeemPoints: "แลกแต้ม",
  myActivityPoints: "แต้มกิจกรรมของฉัน",
  currencySymbol: "สัญลักษณ์สกุลเงิน",
  basicInformation: "ข้อมูลพื้นฐาน",
  personalReports: "รายงานส่วนตัว",
  loginPassword: "รหัสผ่านเข้าสู่ระบบ",
  paymentPassword: "รหัสผ่านการชำระเงิน",
  taskLog: "บันทึกงาน",
  Fundingdetails: "รายละเอียดการเงิน",
  noticeAnnouncement: "ประกาศ",
  onlineService: "บริการออนไลน์",
  logOut: "ออกจากระบบ",
  residence: "ที่อยู่อาศัย",
  reservationNow: "จองตอนนี้",
  photo: "รูปภาพ",
  video: "วิดีโอ",
  personalProfile: "ข้อมูลส่วนตัว",
  popularRecommendations: "แนะนำยอดนิยม",
  switchWindows: "สลับหน้าต่าง",
  designatedTime: "เวลาที่กำหนด",
  votingResults: "ผลการโหวต",
  ISSUE: "หมายเลขงวด",
  data: "ข้อมูลผลรางวัล",
  big: "ใหญ่",
  small: "เล็ก",
  one: "หนึ่ง",
  two: "สอง",
  currentSelectedNumber: "หมายเลขที่เลือกปัจจุบัน",
  pointsPerOrder: "แต้มต่อรายการ",
  inTotal: "รวมทั้งหมด",
  amountMoney: "จำนวนเงิน",
  availablePoints: "แต้มที่ใช้ได้",
  submitTo: "ยืนยัน",
  artilleryEngagement: "กิจกรรมนัดเดท",
  recharge: "เติมเงิน",
  Withdrawal: "ถอนเงิน",
  AccountDetails: "รายละเอียดบัญชี",
  SystemOperation: "การดำเนินการระบบ",
  payeeName: "ชื่อผู้รับเงิน",
  bankName: "หมายเลขบัญชีรับเงิน",
  bankCardNumber: "หมายเลขบัตรธนาคาร",
  bankCardNumberPlaceholder: "กรุณากรอกหมายเลขบัตรธนาคาร",
  branchName: "ชื่อสาขา",
  branchNumber: "รหัสสาขา",
  selectBank: "กรุณากรอกข้อมูลบัญชีการชำระเงินของคุณ",
  nameOfPayer: "ชื่อผู้ชำระเงิน",
  uploadPaymentVoucher: "อัปโหลดหลักฐานการชำระเงิน",
  rechargePrompt:
    "กรุณาอย่าทำซ้ำ หากเงินไม่เข้าเป็นเวลานาน กรุณาติดต่อฝ่ายบริการลูกค้า",
  confirmRecharge: "ยืนยันการเติมเงิน",
  exchangeRecords: "ประวัติการแลกเปลี่ยน",
  whole: "ทั้งหมด",
  limitDescription: "รายละเอียดวงเงิน",
  singleTransactionLimit: "วงเงินต่อรายการ",
  minimum: "ต่ำสุด",
  highest: "สูงสุด",
  withdrawalFrequency: "จำนวนครั้งถอนเงิน",
  dailyHighest: "สูงสุดต่อวัน",
  order: "รายการ",
  freeOfHandlingFees: "(ค่าธรรมเนียมฟรีสูงสุด 500 รายการ)",
  receiptTime: "เวลาที่เงินเข้า: ปกติประมาณ 5 นาที เร็วสุด 2 นาที",
  residualIntegral: "แต้มคงเหลือ",
  individual: "ส่วนบุคคล",
  redeemPointsNow: "แลกทันที",
  headSculpture: "รูปโปรไฟล์",
  fullName: "ชื่อผู้รับเงิน",
  gender: "เพศ",
  male: "ชาย",
  female: "หญิง",
  unknown: "ไม่ทราบ",
  bankCardInformation: "ข้อมูลบัญชีรับเงิน",
  have: "มี",
  notHave: "ไม่มี",
  modifyRealName: "แก้ไขชื่อจริง",
  save: "บันทึก",
  fullNamePlaceholder: "กรุณากรอกชื่อจริง",
  modifyRealNameRemake:
    "เพื่อความปลอดภัย ชื่อต้องตรงกับชื่อบัญชีธนาคารที่ผูกไว้",
  modifyGender: "แก้ไขเพศ",
  cardNumber: "หมายเลขบัตรธนาคาร",
  cardName: "ชื่อผู้ใช้",
  cardID: "บัญชีธนาคาร",
  addBankCard: "เพิ่มบัญชีการชำระเงิน",
  addBankCardRemake:
    "คำแนะนำ: กรุณาเพิ่มบัญชี Paypal ของคุณ หากต้องการแก้ไขโปรดติดต่อฝ่ายบริการลูกค้า",
  addBankCardRemake2:
    "คำเตือน: [เมื่อคุณติดต่อฝ่ายบริการลูกค้าเพื่อฝากเงินผ่าน Paypal] เพื่อหลีกเลี่ยงการทำธุรกรรมที่ไม่เหมาะสมกับสาวๆ และความเสี่ยงทางกฎหมายที่ไม่จำเป็น แพลตฟอร์มนี้รองรับเฉพาะการชำระเงินแบบ PayPal Friends & Family หากเลือกการชำระเงินแบบธุรกิจจะถือว่าเป็นการชำระเงินที่ไม่ถูกต้องและแพลตฟอร์มจะไม่ดำเนินการ",
  payCardInfoPlaceholder: "กรุณากรอกข้อมูลบัญชีการชำระเงินของคุณ",
  addBankCardPrompt:
    "เพื่อความปลอดภัยของเงินของคุณ โปรดกรอกหมายเลขบัญชีการชำระเงินของคุณให้ถูกต้องและตั้งรหัสผ่านสำหรับการถอนเงิน การกรอกข้อมูลที่ไม่ถูกต้องอาจทำให้เงินของคุณไม่ได้รับตรงเวลา!",
  personalReport: "รายงานส่วนบุคคล",
  profitPoints: "แต้มรายได้",
  profiCalculationFormula: "สูตรการคำนวณรายได้: แต้มที่ชนะ - แต้มภารกิจ",
  taskPoints: "แต้มภารกิจ",
  withdrawalPoints: "แต้มถอนเงิน",
  winningPoints: "แต้มที่ชนะ",
  changeLoginPassword: "เปลี่ยนรหัสผ่านเข้าสู่ระบบ",
  oldPwd: "รหัสผ่านเก่า",
  oldPwdPlaceholder: "กรุณากรอกรหัสผ่านเก่า",
  newPwd: "รหัสผ่านใหม่",
  newPwdPlaceholder: "กรุณากรอกรหัสผ่านใหม่",
  againOldPwdPlaceholder: "กรุณากรอกรหัสผ่านใหม่อีกครั้ง",
  taskRecord: "บันทึกภารกิจ",
  emptyData: "ไม่มีข้อมูล",
  betPoints: "แต้มเดิมพัน",
  orderTime: "เวลาสั่งซื้อ",
  settlementTime: "เวลาเคลียร์ยอด",
  refreshSuccessful: "รีเฟรชสำเร็จ",
  invalidFunction: "ฟังก์ชันนี้ไม่สามารถใช้งานได้",
  appointmentSuccessful: "จองสำเร็จ",
  completeActivationTask: "ติดต่อฝ่ายบริการลูกค้าเพื่อรับบัตรนัดเดท",
  checkAgreement: "กรุณาติ๊กยอมรับข้อตกลงบัญชี",
  integralError: "แต้มผิดพลาด",
  selectNumber: "กรุณาเลือกหมายเลข",
  fillInPoints: "กรุณากรอกจำนวนแต้ม",
  txjebndyye: "จำนวนเงินถอนต้องไม่เกินยอดเงินคงเหลือในบัญชี",
  insufficientPoints: "แต้มไม่เพียงพอ กรุณาติดต่อฝ่ายบริการลูกค้า",
  contactCollect: "กรุณาติดต่อผู้ดูแลเพื่อรับภารกิจนี้",
  successfulLotteryDraw: "ออกรางวัลสำเร็จ หมายเลขงวด:",
  notSet: "ยังไม่ได้ตั้งค่า",
  contactService: "หากต้องการแก้ไขรหัสผ่าน กรุณาติดต่อฝ่ายบริการลูกค้า",
  completeTask: "กรุณาทำภารกิจให้เสร็จและกรอกตามที่กำหนด",
  setUpBankCard: "กรุณาตั้งค่าบัตรธนาคาร",
  accountOffline: "บัญชีออฟไลน์",
  fileTooLarge: "ไฟล์มีขนาดใหญ่เกินไป",
  formatRule: "กรุณาอัปโหลดรูปภาพในรูปแบบที่ถูกต้อง",
  uploadSuccessful: "อัปโหลดสำเร็จ",
  amountError: "จำนวนเงินผิดพลาด",
  setNameToBindBankCard: "กรุณาตั้งชื่อและผูกบัตรธนาคาร",
  setWithdrawalPasswordToBindBankCard: "กรุณาตั้งรหัสถอนเงินและผูกบัตรธนาคาร",
  passwordInconsistency: "รหัสผ่านไม่ตรงกัน",
  complete: "กรุณากรอกข้อมูลให้ครบถ้วน",
  changWithdrawalPasswordContactSustomerService:
    "รหัสถอนเงินถูกตั้งแล้ว หากต้องการแก้ไขโปรดติดต่อฝ่ายบริการลูกค้า",
  activateWatchVideo: "ดูวิดีโอได้หลังจากทำภารกิจเสร็จ",
  rechargeWatchVideo: "ดูวิดีโอได้หลังจากเติมเงิน",
  pour: "เดิมพัน",
  taskList: "รายการภารกิจ",
  clearOrder: "ล้างรายการ",
  confirmSub: "ยืนยันการส่ง",
  switchLanguage: "เปลี่ยนภาษา",
  illustrate: "คำอธิบาย",
  submissionTime: "เวลาส่ง",
  auditTime: "เวลาตรวจสอบ",
  oldPayPwd: "รหัสชำระเงินเก่า (ค่าเริ่มต้น 0000 หากไม่ได้ตั้ง)",
  payPwdPl: "กรุณากรอกรหัสชำระเงิน",
  enterPayPwdPl: "กรุณากรอกรหัสชำระเงินอีกครั้ง",
  setPayPwd: "ตั้งรหัสชำระเงิน",
  yse: "ใช่",
  creditScore: "แต้มเครดิต",
  sdintroduce:
    "การท่องเที่ยวทั้งในและต่างประเทศอยู่ในแพลตฟอร์มจองที่พักชั้นนำของประเทศ ครอบคลุมโรงแรม ตั๋วเครื่องบิน และอีกมากมาย พร้อมรับส่วนลดพิเศษ!",
  Membershipincome: "รายได้สมาชิก",
  Balance: "ยอดคงเหลือ",
  Income: "รายได้วันนี้",
  Totaldeposit: "จำนวนภารกิจ",
  Totalwithdrawal: "รายได้รวม",
  GrabOrder: "เริ่มภารกิจ",
  popularRestaurant: "โรงแรมยอดนิยม",
  Restaurantname: "ชื่อโรงแรม",
  Totalamount: "ยอดรวม",
  Commission: "ค่าคอมมิชชั่น",
  Ordernumber: "หมายเลขคำสั่งซื้อ",
  Submissiontime: "เวลาส่ง",
  Submit: "ส่ง",
  History: "ประวัติ",
  All: "ทั้งหมด",
  Pending: "รอดำเนินการ",
  Completed: "เสร็จสิ้น",
  Pay: "ชำระเงิน",
  reviews: "รีวิว",
  MAD: "฿",
  includestaxescharges: "รวมภาษีและค่าบริการ",
  Expectedreturn: "รายได้ที่คาดหวัง",
  Detail: "รายละเอียด",
  freeze: "แช่แข็ง",
  OrderQuantity: "จำนวนคำสั่งซื้อ",
  OrderQuantityTxt: "คำสั่งซื้อถูกสร้างโดยระบบ: เดี่ยวหรือหลายรายการ",
  loadingtext: "กำลังโหลด",
  finishedtext: "ไม่มีข้อมูลเพิ่มเติม",
  pullingtext: "ดึงลงเพื่อรีเฟรช",
  loosingtext: "ปล่อยเพื่อรีเฟรช",
  Payremainingtime: "เวลาที่เหลือสำหรับการชำระเงิน",
  trade: "ธุรกรรม",
  Rebate: "ค่าคืน",
  ForcedTransaction: "ธุรกรรมบังคับ",
  PromotionRebate: "ค่าคืนจากการโปรโมท",
  Subleveltransactionrebate: "ค่าคืนจากธุรกรรมของระดับรอง",
  Rules: "คำอธิบายกฎ",
  confirmButtonText: "ยืนยัน",
  CreditScore: "คะแนนเครดิต",
  VerifyDECardNumber: "กรุณาผูกบัญชีธนาคารระหว่างประเทศที่ขึ้นต้นด้วย DE",
  AdultVideos: "ช่องสำหรับผู้ใหญ่ 18+",
  v0tips1: "นัดเดทสำเร็จ",
  v0tips2:
    "แพลตฟอร์มจะมอบห้องสวีทสุดหรูสำหรับคู่รักเป็นสิทธิพิเศษสำหรับการพบกันครั้งแรก",
  v0tips3: "แสดงตัวอย่างโรงแรมหรูบางส่วนที่ร่วมรายการ",
  serviceTip:
    "คุณต้องติดต่อฝ่ายบริการลูกค้าของแพลตฟอร์มผ่าน Telegram หรือ WhatsApp เพื่อขอนัดเดทกับสาวและรับข้อมูลติดต่อของเธอ",
  DefaultPassword: "รหัสผ่านเริ่มต้นคือ 0000",
  PassionateMovies: "ภาพยนตร์ที่น่าหลงใหล",
};
